import imageProxy from '@/js/common/Domain/Service/imageProxy';
import template from './template.html';

export default class RoomCategoryPhotos extends Backbone.Epoxy.View {
    initialize() {
        this.render();
     }

    render() {
        const roomDescriptionPhotos = this.model.get('room')?.photos || [];
        if (roomDescriptionPhotos?.length) {
            this.$el.html(template({
                photos: roomDescriptionPhotos,
                imageProxy,
            }));
        } else {
            this.$el.empty();
        }
    }
}